/**
 * This set of components is used to define the layout of sql template forms. Every form should be
 * wrapped with SQLTemplateFormWrapper, which defines the flex layout mode, and every step in the form
 * should be wrapped with SQLTemplateFormStepWrapper, which defines the padding and flex layout of individual
 * steps/columns in the form.
 */
import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {PANE_MARGIN} from 'insights/InsightsConstants';
import {Header3} from 'ui-library/Headers';

interface SQLTemplateFormStepWrapperProps {
  children: ReactNode;
  title: string;
}

export function SQLTemplateFormStepWrapper(props: SQLTemplateFormStepWrapperProps): JSX.Element {
  return (
    <div className={css(styles.formStepWrapper)}>
      <Header3>{props.title}</Header3>
      <div className="u-spacing-left">{props.children}</div>
    </div>
  );
}

interface SQLTemplateFormWrapperProps {
  children: ReactNode;
}

export default function SQLTemplateFormWrapper(props: SQLTemplateFormWrapperProps): JSX.Element {
  return <form className={css(styles.formWrapper)}>{props.children}</form>;
}

const styles = StyleSheet.create({
  formWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    margin: PANE_MARGIN,
  },
  formStepWrapper: {
    paddingRight: 50,
    flexGrow: 0,
    ':last-child': {
      flexGrow: 1,
      paddingRight: 0,
    },
  },
});
